import React from "react";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { projects } from "../portfolio";
import { useLanguage } from "../i18n/LanguageContext";

const GithubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.55v-2.15c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.69-1.28-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.19 1.76 1.19 1.03 1.75 2.69 1.25 3.34.95.1-.74.4-1.25.72-1.53-2.55-.29-5.23-1.28-5.23-5.69 0-1.26.45-2.28 1.19-3.09-.12-.29-.52-1.46.11-3.05 0 0 .97-.31 3.17 1.18a11 11 0 0 1 5.78 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.59.23 2.76.11 3.05.74.81 1.19 1.83 1.19 3.09 0 4.42-2.69 5.39-5.25 5.68.41.35.77 1.05.77 2.12v3.14c0 .3.21.67.8.55A11.51 11.51 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z" />
  </svg>
);

const LinkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14L21 3" />
  </svg>
);

const Projects = () => {
  const { t } = useLanguage();

  return (
    <section className="cine-section" id="projects">
      <div className="cine-container">
        <SectionHead eyebrow={t.projects.eyebrow} title={t.projects.title} lead={t.projects.lead} />

        <div className="projects-grid">
          {projects.map((project, i) => (
            <Reveal key={project.name} delay={(i % 3) * 100}>
              <article className="cine-glass cine-tilt cine-sheen project-card">
                {project.preview && (
                  <div className="project-thumb">
                    <img src={project.preview} alt={`${project.name} preview`} loading="lazy" />
                  </div>
                )}
                <div className="project-body">
                  <h3 className="project-name">{project.name}</h3>
                  <div className="project-links">
                    {project.link && (
                      <a className="project-link" href={project.link} target="_blank" rel="noreferrer">
                        <LinkIcon />
                        {t.projects.live}
                      </a>
                    )}
                    {project.github && (
                      <a className="project-link" href={project.github} target="_blank" rel="noreferrer">
                        <GithubIcon />
                        {t.projects.code}
                      </a>
                    )}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
